import React, { Component } from "react";

class NetZeroLoader extends Component {
  render() {
    return (
      <div
        className="siteLoaderActiveBackground"
        style={{ zIndex: this.props.addZIndex ? 9 : "" }}
      >
        <img src="/img/net-zero-logo-icon.svg" class="logoIcon" alt="loading" />
      </div>
    );
  }
}

export default NetZeroLoader;
